import React from "react";
import { SiteRenderer } from "../site/SiteRenderer";
import { useSiteLayout } from "../site/useSiteLayout";
import { PageLoader } from "../components/LoadingRing";
import { usePageSeo } from "../lib/usePageSeo";
import { crumbsJsonLd } from "../lib/seoHead";

// Pages that have a builder layout render it; otherwise the hand-built page stays in place.
export default function ManagedRoute({ slug, fallback }) {
    const { page, sections, loading, editing, selectedId, onSelect, onEditText } = useSiteLayout(slug);
    // The CMS layout replaces the hand-built page, so the SEO tags have to come from the CMS row.
    const seo = page?.seo || {};
    usePageSeo(page && !editing ? {
        title: seo.seo_title || page.title || "ReHealthMe",
        description: seo.meta_description || page.description || "",
        canonical: seo.canonical_url || `${window.location.origin}/${slug}`,
        image: seo.social_image || "",
        noindex: !!seo.noindex,
        jsonLd: [crumbsJsonLd([
            { name: "Home", path: "/" },
            { name: page.title || slug, path: `/${slug}` },
        ])],
    } : null);
    if (loading) return (
        <div className="bg-bg0 min-h-screen flex items-center justify-center" data-testid={`managed-${slug}-loading`}>
            <PageLoader label="LOADING…" className="" />
        </div>
    );
    if (!sections?.length) return fallback;
    return (
        <div data-testid={`managed-page-${slug}`}>
            <SiteRenderer sections={sections} editing={editing} selectedId={selectedId}
                onSelect={onSelect} onEditText={onEditText} />
        </div>
    );
}
